import { jsx as C } from "react/jsx-runtime";
const l = ({
  width: o,
  height: t,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 11 18",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M10.661 0.329003C10.6152 0.245177 10.551 0.172857 10.4731 0.117513C10.3953 0.0621697 10.3059 0.0252508 10.2117 0.00954843C10.1174 -0.00615393 10.0209 -0.000228649 9.9293 0.0268762C9.83772 0.0539811 9.7535 0.101556 9.683 0.166003L0.283001 8.343C0.195277 8.42702 0.125466 8.52791 0.077774 8.63962C0.030082 8.75133 0.00549316 8.87154 0.00549316 8.993C0.00549316 9.11447 0.030082 9.23467 0.077774 9.34638C0.125466 9.45809 0.195277 9.55899 0.283001 9.643L9.683 17.833C9.79807 17.9367 9.94711 17.9947 10.102 17.996C10.2152 17.9937 10.3259 17.9625 10.4238 17.9055C10.5216 17.8484 10.6032 17.7674 10.661 17.67C10.772 17.4926 10.8186 17.2824 10.7931 17.0747C10.7676 16.867 10.6716 16.6743 10.521 16.529L1.862 8.995L10.517 1.456C10.6679 1.31396 10.7648 1.1239 10.791 0.91832C10.8173 0.712745 10.7713 0.504429 10.661 0.329003Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as Content
};
